import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce0159bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }

import RouterUtils from "@/common/utils/router.util";

// Vue関連のインポート
import { ref } from "vue";
import { useStore } from "vuex";

// 定数のインポート
import RouterConstants from "../constants/router.constants";

// 型定義のインポート
import { BookingViewPageTypeEnum } from "../typings/enums/booking";
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

/** Vuexストアのインスタンス */

export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  setup(__props) {

/**
 * サイドバーナビゲーションコンポーネント
 * アプリケーションのメインナビゲーションメニューを提供する
 */

// ユーティリティのインポート
const store = useStore();

/** メニューのテンプレート参照 */
const menu = ref();

/**
 * 未提携クリニックかどうかを判定
 * @returns {boolean} 未提携クリニックの場合true
 */
const isUnaffiliated = () => {
  return store.getters["authClient/selectedClinic"].partner == ClinicPartner.Unaffiliated;
};

/**
 * サイドバーメニューのアイテム定義
 * 各メニュー項目のラベル、アイコン、コマンドを定義
 */
const items = ref([
  // {
  //   label: "ダッシュボード",
  //   icon: "icon-lms icon-lms_home",
  //   command: () => {
  //     RouterUtils.goTo(RouterConstants.DASHBOARD_ROUTER_NAME);
  //   },
  // },
  {
    label: "予約管理",
    icon: "icon-lms icon-lms_calendar",
    command: () => {
      RouterUtils.goToWithQuery(RouterConstants.BOOKING_ROUTER_NAME, {
        view_page: BookingViewPageTypeEnum.StaffCalendar,
      });
    },
  },
  {
    label: "顧客管理",
    icon: "icon-lms icon-lms_group small",
    command: () => {
      RouterUtils.goTo(RouterConstants.CUSTOMER_ROUTER_NAME);
    },
  },
  // {
  //   label: "リッチメニュー",
  //   icon: "icon-lms icon-lms_menu",
  //   command: () => {
  //     RouterUtils.goTo(RouterConstants.RICH_MENU_ROUTER_NAME);
  //   },
  // },
  {
    label: "トーク",
    icon: "icon-lms icon-lms_chat",
    command: () => {
      RouterUtils.goTo(RouterConstants.DIRECT_MESSAGE_ROUTER_NAME);
    },
  },
  {
    label: "タグ配信",
    icon: "icon-lms icon-lms_evelop small",
    items: [
      {
        label: "配信グループ一覧",
        command: () => {
          RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUP_ROUTER_NAME);
        },
      },
      {
        label: "下書き一覧",
        command: () => {
          RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUPS_DRAFTS_NAME);
        },
      },
    ],
  },
  {
    label: "ルーティン配信（※ベータ版）",
    icon: "icon-lms icon-lms_send small",
    items: [
      {
        label: "ルーティン配信一覧",
        command: () => {
          RouterUtils.goTo(RouterConstants.DISTRIBUTION_ROUTINE_GROUP_ROUTER_NAME);
        },
      },
      {
        label: "ルーティン配信下書き一覧",
        command: () => {
          RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUPS_ROUTINE_DRAFTS_NAME);
        },
      },
    ],
  },
  // {
  //   label: "配信サマリー",
  //   icon: "icon-lms icon-lms_campaign small",
  //   command: () => {
  //     RouterUtils.goTo(RouterConstants.TAGGED_DELIVERY_ROUTER_NAME);
  //   },
  // },
  // {
  //   label: "メッセージ配信",
  //   icon: "icon-lms icon-lms_evelop small",
  //   command: () => {
  //     RouterUtils.goTo(RouterConstants.MESSAGE_ROUTER_NAME);
  //   },
  // },
  // {
  //   label: "キャンペーン配信",
  //   icon: "icon-lms icon-lms_campaign",
  //   command: () => {
  //     RouterUtils.goTo(RouterConstants.CAMPAIGN_ROUTER_NAME);
  //   },
  // },
  {
    label: "設定",
    icon: "icon-lms icon-lms_gear",
    items: [
      {
        label: "カテゴリー",
        visible: isUnaffiliated,
        command: () => {
          RouterUtils.goTo(RouterConstants.MEDICAL_MENU_CATEGORY_ROUTER_NAME);
        },
      },
      {
        label: "メニュー",
        command: () => {
          RouterUtils.goTo(RouterConstants.MENU_ROUTER_NAME);
        },
      },
      {
        label: "部屋・設備予約",
        command: () => {
          RouterUtils.goTo(RouterConstants.ROOMS_ROUTE_NAME);
        },
      },
      {
        label: "メニュータグ登録",
        visible: isUnaffiliated,
        command: () => {
          RouterUtils.goTo(RouterConstants.SERVICE_TAGS_ROUTER_NAME);
        },
      },
      {
        label: "セグメント用手動タグ登録",
        visible: isUnaffiliated,
        command: () => {
          RouterUtils.goTo(RouterConstants.SEGMENT_MANUAL_TAGS_ROUTER_NAME);
        },
      },
      {
        label: "オプションメニュー",
        command: () => {
          RouterUtils.goTo(RouterConstants.MEDICAL_OPTIONS_ROUTER_NAME);
        },
      },
      {
        label: "基本設定",
        visible: isUnaffiliated,
        command: () => {
          RouterUtils.goTo(RouterConstants.BOOKING_SETTING_ROUTER_NAME);
        },
      },
      {
        label: "基本営業日設定",
        visible: isUnaffiliated,
        command: () => {
          RouterUtils.goTo(RouterConstants.CLINIC_DAILY_ROUTINE_ROUTER_NAME);
        },
      },
      {
        label: "スタッフ一覧",
        visible: isUnaffiliated,
        command: () => {
          RouterUtils.goTo(RouterConstants.STAFF_LIST_ROUTER_NAME);
        },
      },
      {
        label: "スタッフシフト",
        visible: isUnaffiliated,
        command: () => {
          RouterUtils.goTo(RouterConstants.STAFF_SHIFT_ROUTER_NAME);
        },
      },
      {
        label: "予約自動振り分け設定",
        visible: isUnaffiliated,
        command: () => {
          RouterUtils.goTo(RouterConstants.STAFF_PRIORITIES_ROUTER_NAME);
        },
      },
      {
        label: "お知らせテンプレート",
        command: () => {
          RouterUtils.goTo(RouterConstants.LINE_NOTIFICATION_MESSAGE_ROUTER_NAME);
        },
      },
      {
        label: "定型文一覧",
        command: () => {
          RouterUtils.goTo(RouterConstants.LIVE_MESSAGE_TEMPLATE_ROUTER_NAME);
        },
      },
      {
        label: "予約通知",
        command: () => {
          RouterUtils.goTo(RouterConstants.BOOKING_NOTIFICATIONS_ROUTE_NAME);
        },
      },
    ],
  },
  // {
  //   label: "お問合せ",
  //   icon: "icon-lms icon-lms_contact",
  //   command: () => {
  //     RouterUtils.goTo(RouterConstants.CONTACT_ROUTER_NAME);
  //   },
  // },
]);

return (_ctx: any,_cache: any) => {
  const _component_TieredMenu = _resolveComponent("TieredMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TieredMenu, {
      ref_key: "menu",
      ref: menu,
      id: "overlay_tmenu",
      model: items.value
    }, null, 8, ["model"])
  ]))
}
}

})